export const uuidNumber = (uuid?: string) => (uuid ?? "").split("-")[0];
